import {observer} from "mobx-react";
import {useStore} from "@/store";
import {useEffect} from "react";
import styled from "styled-components";
import {FiHome} from "react-icons/fi";
import {BsCaretRightFill} from "react-icons/bs";
import {SIZES} from "@/components/constants";
import 'swiper/css';
import {useSearchParams} from "next/navigation";
import {getCurrentNode} from "@/utils/menu";

const PageInformation = observer(({scrollRef}) => {
    const {navigationStore} = useStore();
    const params = useSearchParams();

    const menuId = params.get("menu-id");
    useEffect(() => {
        return () => {
            navigationStore.resetPageMenu();
        };
    }, []);




    return(
        <PageInformationWrap className={"site-page-info"}>
            {
                menuId &&
                navigationStore.navigateList &&
                <>
                    {
                        getCurrentNode(navigationStore.navigateList, menuId).trail &&
                        getCurrentNode(navigationStore.navigateList, menuId).trail.length > 0 &&
                        <div className={"bread-crumb-wrap"}>
                            <div className={"home"}><FiHome size={24}/></div>
                            {
                                getCurrentNode(navigationStore.navigateList, menuId).trail.map((item, key) =>
                                    <div key={key} className={"bread-crumb-list"}>
                                        <div className={"path"}>{item.title}</div>
                                        {key < getCurrentNode(navigationStore.navigateList, menuId).trail.length - 1 &&
                                            <span><BsCaretRightFill size={10}/></span>}
                                    </div>
                                )
                            }
                        </div>
                    }
                    {
                        getCurrentNode(navigationStore.navigateList, menuId) &&
                        <div className={`head-current-text-wrap ${getCurrentNode(navigationStore.navigateList, menuId).subType === "COOPERATION" ? "cooperation" : ""}`}>
                            <div className={`current-title`}>
                                {
                                    getCurrentNode(navigationStore.navigateList, menuId).menuId === "68db6633655492292e882c68"
                                        ? (
                                            <div className={"social-wrap"}>
                                                사회공헌 활동
                                                <span>비투게더edu (BeeTogether education)</span>
                                            </div>
                                        )
                                        : getCurrentNode(navigationStore.navigateList, menuId).title
                                }
                            </div>
                            {
                                getCurrentNode(navigationStore.navigateList, menuId).options?.headSubTitle &&
                                <div className={"current-sub-title"}>
                                    <p>{getCurrentNode(navigationStore.navigateList, menuId).options.headSubTitle}</p>
                                </div>
                            }
                        </div>
                    }
                </>
            }
        </PageInformationWrap>
    )
});

const PageInformationWrap = styled.div`
    padding-top: 72px;

    .bread-crumb-wrap {
        width: 100%;
        padding: 0 144px;
        display: flex;
        align-items: center;
        gap: 14px;

        .bread-crumb-list {
            gap: 14px;
            display: flex;
            align-items: center;

            .path {
                font-weight: 500;
                font-size: 16px;
                letter-spacing: -0.02em;
                color: #000000;
            }
            span{
                display: flex;
                align-items: center;
            }
        }
    }

    .head-current-text-wrap {
        padding: 40px 0;

        .current-title {
            font-weight: 700;
            font-size: 54px;
            line-height: 64px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #000000;

            .social-wrap {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 24px;

                span {
                    font-weight: 400;
                    font-size: 24px;
                    line-height: 36px;
                    text-align: center;
                    letter-spacing: -0.02em;
                    color: #666666;
                }
            }
        }

        .current-sub-title {
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            letter-spacing: -0.02em;
            margin-top: 24px;
            color: #666666;
            white-space: pre-line;
        }
    }

    .depth-list-placeholder {
        width: 100%;
    }


    @media (max-width: ${SIZES.TABLET}) {
        padding: 0;
        .bread-crumb-wrap{
            display: none;
        }
        .head-current-text-wrap{
            padding: 24px 8px;

            .current-title{
                font-size: 24px;
                line-height: 36px;

                .social-wrap{
                    gap: 16px;

                    span{
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 28px;
                        letter-spacing: -0.02em;
                    }
                }
            }

            .current-sub-title{
                font-size: 18px;
                font-weight: 500;
                line-height: 28px;
                margin-top: 16px;
            }
        }

        
    }
`;

export default PageInformation;
